import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";

import { storeInstance } from "store/index.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import "./kb-parentpath.js";

class KbSearchview extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.searchresults = this.state.search_results
      ? this.state.search_results
      : [];
    if (this.state.search_term) {
      // this.refreshData()
    }
    this.myRender();
    storeInstance.dispatch("getPanelSearchResults");
  }

  refreshData() {
    // storeInstance.dispatch("search", {langCode: this.state.langCode, externalId: this.state.search_term.item, searchterm: this.state.search_term.searchterm })
    storeInstance.dispatch("getPanelSearchResults");
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.itemFilterDisplayName = "";

    if (this.state.search_term) {
      if (this.state.search_term.searchterm != this.lastSearchTerm) {
        this.lastSearchTerm = this.state.search_term.searchterm;
        this.refreshData();
      }

      if (this.state.search_term.item) {
        if (this.state.search_term.item != "ROOT") {
          this.itemFilter = this.state.search_term.item;
          this.itemFilterDisplayName = this.state.item.itemLang.name;
        }
      }
    }

    this.searchresults = this.state.search_results
      ? this.state.search_results
      : [];
    this.myRender();
  }

  myRender() {
    render(this.searchViewTemplate(), this.shadowRoot);
  }

  _pageHitsArray(item) {
    var retval = [];
    if (item.pageHits) {
      let responseDoc = new DOMParser().parseFromString(
        item.pageHits,
        "application/xml"
      );
      var pageInfo = responseDoc.getElementsByTagName("pageInfo");
      if (pageInfo.length > 0) {
        for (var i = 0; i < pageInfo.length; i++) {
          var pageNumEl = pageInfo[i].getElementsByTagName("pageNum");
          var pageTextEl = pageInfo[i].getElementsByTagName("pageHitText");
          if (pageNumEl[0] && pageTextEl[0]) {
            retval.push({
              hitText: pageTextEl[0].innerHTML,
              pageNum: pageNumEl[0].innerHTML,
            });
          }
        }
      }
    }
    return retval;
  }

  _populatePageHitsArray(item) {
    this.pageArray = [];
    this.numPageArrayColumns = 1;
    if (item.pageHits) {
      let responseDoc = new DOMParser().parseFromString(
        item.pageHits,
        "application/xml"
      );
      var pageInfo = responseDoc.getElementsByTagName("pageInfo");
      //var pageNumCollection = responseDoc.getElementsByTagName("pageNum")
      if (pageInfo.length > 0) {
        for (var i = 0; i < pageInfo.length; i++) {
          var pageNumEl = pageInfo[i].getElementsByTagName("pageNum");
          var pageTextEl = pageInfo[i].getElementsByTagName("pageHitText");
          if (pageNumEl && pageTextEl) {
            this.pageArray.push({
              hitText: pageTextEl.innerHTML,
              pageNum: pageNumEl.innerHTML,
            });
          }
        }
      }
    }
    if (this.pageArray.length > 0) {
      this.numPageArrayColumns = Math.floor(this.pageArray.length / 5);
    } else {
      this.numPageArrayColumns = 1;
    }
    if (this.numPageArrayColumns == 0) {
      this.numPageArrayColumns = 1;
    }
    if (this.numPageArrayColumns > 1) {
      this.numPageArrayColumns = 1;
    }
  }

  searchViewTemplate() {
    return html`
       <style>
            #searchResultsContainer{
                width: 75%;
            }
            
            .targetsearchword{background-color:var(--target-search-word-highlight-color);}

            .result-item{
                cursor: pointer;
                margin-top:var(--block-padding-vertical-large);
            }
            .result-item h3{
                cursor:pointer;
                margin:0;
                color: var(--kb-text-result-name-color);
            }
            .result-item h3:hover{
                text-decoration:underline;
            }
            .result-item h3:active{
                color: var(--kb-on-surface-link-color-active);
            }
            .result-item h3:visited{
                color: var(--kb-on-surface-link-color-visited);
            }
            .hide{display:none;}
            ul{
                margin-top: .25rem;
            }
            li{
                color:var(--kb-primary-color-400);
            }
            li:hover{
                text-decoration: underline;
            }
            li:active{
                color:var(--kb-on-surface-link-color-active);
            }
            li:visited{
                color:var(--kb-on-surface-link-color-visited);
            }
            .caption{
                font-size: 80%;
                font-style: italic;
                color: var(--kb-text-result-description-color);
            }
            .pagelist{
                column-gap: var(--block-padding);
                width: 50%;
                list-style:none;
            }
            
            .highlight{
                color: var(--on-surface-color-highlight);
            }
      </style>

      
        <div id="searchResultsContainer" >
        <h2 style="margin: 0">${
          this.lastSearchTerm
            ? this.string["_searchresultsfor"]
            : this.string["_allresults"]
        } <span class='highlight'>${this.lastSearchTerm}</span> </h2>
        <h2 class="${!this.itemFilter ? "hide" : ""}">${
      this.string["_resultswithin"]
    }:  <span class='highlight'>${this.itemFilterDisplayName}<span> </h2>

        ${this.searchresults.length < 1 ? html`<p style="margin-top: 2rem;">No search results found.</p>` : null}
        ${this.searchresults.map(
          (item) =>
            html`<div
              class="result-item"
              @click="${this._gotoItem.bind(this, item)}"
            >
              ${this._populatePageHitsArray(item)}
              <h3>${item.topicTitle}</h3>
              ${item.hitText
                ? html`<div>${unsafeHTML(item.hitText)}</div>`
                : null}
              <div class="caption">${item.itemPath}</div>
              <ul
                class="pagelist"
                style="columns: ${this
                  .numPageArrayColumns};-webkit-columns: ${this
                  .numPageArrayColumns};-moz-columns: ${this
                  .numPageArrayColumns};"
              >
                ${this._pageHitsArray(item).map(
                  (hit) =>
                    html`
                      <li
                        @click="${this._pageHitClick.bind(
                          hit.pageNum,
                          item,
                          this
                        )}"
                        id="${hit.pageNum}"
                      >
                        <strong>page ${hit.pageNum}:</strong> ${unsafeHTML(
                          hit.hitText
                        )}
                      </li>
                    `
                )}
              </ul>
            </div>`
        )}
        </div>
        `;
  }

  _pageHitClick(item, that, e) {
    //Currently only folderview hits have page numbers
    e.stopPropagation();
    if (item.kbResId) {
      var pageNum = e.currentTarget.id;
      var strUrl =
        "/kb/" +
        that.state.langCode +
        "/" +
        item.itemExtId +
        "/folder/" +
        item.collId +
        "/" +
        item.kbResId.replace("Xdfv_", "") +
        "/" +
        pageNum;
      Router.go(strUrl);
    }

    if (item.itemType === "filePub") {
      let pageNum = e.currentTarget.id;
      let newUrl =
        "/kb/" + that.state.langCode + "/" + item.itemExtId + "/" + pageNum;
      Router.go(newUrl);
    }
  }
  /*
<div id='search'>
            <ui5-input id='searchbox' @keyup="${this.checkEnterKey.bind(this)}" placeholder="${this.string["_globalsearch"]}" value="${this.state.search_term.searchterm ? this.state.search_term.searchterm : ''}"></ui5-input>
            <iron-icon id="searchbtn" icon="vaadin:search" @click="${this._search.bind(this)}"></iron-icon>
        </div>
*/

  checkEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this._search();
    }
  }

  _search() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    if (searchbox.value) {
      history.pushState(
        null,
        null,
        this.location.pathname + "?q=" + searchbox.value
      );
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: { item: "ROOT", searchterm: searchbox.value },
      });
    } else {
      history.pushState(null, null, this.location.pathname);
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: null,
      });
    }
  }

  _gotoItem(item, e) {
    if (this.id) {
      Router.go(
        "/kb/" +
          this.state.langCode +
          "/" +
          item.itemExtId +
          "/" +
          this.id +
          "/" +
          item.kbResId
      );
    } else {
      if (item.itemType) {
        switch (item.itemType) {
          case "helpset":
            var mode = "";
            if (item.IPC) {
              mode = "ipc";
            } else {
              mode = "topic";
            }
            Router.go(
              "/kb/" +
                this.state.langCode +
                "/" +
                item.itemExtId +
                "/" +
                mode +
                "/" +
                item.kbResId
            );
            break;
          case "folderview":
            //https://localhost:8443/kb/en-US/FV2/folder/79/2379
            var strUrl =
              "/kb/" +
              this.state.langCode +
              "/" +
              item.itemExtId +
              "/folder/" +
              item.collId;
            if (item.kbResId) {
              strUrl =
                "/kb/" +
                this.state.langCode +
                "/" +
                item.itemExtId +
                "/folder/" +
                item.collId +
                "/" +
                item.kbResId.replace("Xdfv_", "");
            }
            Router.go(strUrl);
            break;
          case "download":
            mode = "download";
            Router.go(
              "/kb/" +
                this.state.langCode +
                "/" +
                item.itemExtId +
                "/" +
                mode +
                "/" +
                item.kbResId
            );
            break;
          case "filePub":
            var strUrl = "/kb/" + this.state.langCode + "/" + item.itemExtId;
            Router.go(strUrl);
            break;
        }
      }
    }
  }

  _isIpc(itemLang) {
    var retval = false;
    if (itemLang.hasOwnProperty("flags")) {
      if (itemLang.flags == 1) {
        retval = true;
      }
    }
    return retval;
  }
}

customElements.define("kb-searchview", KbSearchview);
